import React from "react";
import PropTypes from "prop-types";

import { Variables } from "../../styles/Variables";
import PrimaryNormal from "../../components/buttons/PrimaryNormal";

import { Modal, Content, ContainerButtons, TextQuestion } from "./styles";

const ModalOldQuestion = ({ modalOpen, pressYes, pressNo }) => {
  return (
    modalOpen && (
      <Modal>
        <Content>
          <TextQuestion>¿El usuario que se va a inscribir a la salud es mayor de 18 años?</TextQuestion>
          <ContainerButtons>
            <PrimaryNormal
              title="Si"
              style={{ marginBottom: 0, backgroundColor: Variables.colorOrange, width: "45%" }}
              onClick={pressYes}
            />
            <PrimaryNormal title="No" style={{ marginBottom: 0, width: "45%" }} onClick={pressNo} />
          </ContainerButtons>
        </Content>
      </Modal>
    )
  );
};

ModalOldQuestion.propTypes = {
  modalOpen: PropTypes.bool,
  pressYes: PropTypes.func,
  pressNo: PropTypes.func,
};

export default ModalOldQuestion;
